import { motion } from 'framer-motion';
import { BITTE_IMG } from '../../../lib/images';

const DefaultWelcomeScreen = () => {
  return (
    <motion.div
      className="bitte-flex bitte-flex-col bitte-gap-4 bitte-items-center bitte-justify-center bitte-absolute bitte-inset-0 bitte-text-center bitte-px-4"
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 }}
    >
      <img className="bitte-mx-auto bitte-mb-4" src={BITTE_IMG} alt="Bitte" />
      <div className="bitte-mb-14 bitte-text-[20px] bitte-font-medium bitte-text-gray-40">
        Execute Transactions with AI
      </div>
    </motion.div>
  );
};

export default DefaultWelcomeScreen;
